// extracted by mini-css-extract-plugin
export default {"interactionOption":"styles_interactionOption__LEfMf"};